<template lang="pug">
shListData(title="Configuraciones" resolver="configs" keyData="config" component="shConfig")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Configs',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/config/Configs.vue